import { Button } from '@faxi/web-component-library';
import { InfoModal } from 'components';
import parse from 'html-react-parser';
import { FC, memo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { breakTranslationNewlines } from 'utils';

import { InfoModalRef } from '../../../../../components/_molecules/InfoModal/InfoModal.component';

const LegalNoteModal: FC = () => {
  const { t } = useTranslation();

  const infoModalRef = useRef<InfoModalRef>(null);

  return (
    <InfoModal
      ref={infoModalRef}
      trigger={
        <Button
          onClick={() => infoModalRef.current?.open()}
          variant="ghost"
          className="cedolauto-find-dealer-form__privacy-policy__button"
        >
          {t('section_5-step_3-disclaimer-checkbox_link')}
        </Button>
      }
      title={
        parse(breakTranslationNewlines(t('privacy-policy-title'))) as string
      }
    >
      {/* TODO: check which link should be here*/}
      {parse(
        breakTranslationNewlines(
          [
            t('privacy-policy-intro-line_1', { domain: '' }),
            t('privacy-policy-intro-line_1'),
            t('privacy-policy-intro-line_2'),
          ].join('\\n\\n')
        )
      )}

      <strong>{parse(t('privacy-policy-section_A-title'))}</strong>
      {parse(
        breakTranslationNewlines(
          [
            t('privacy-policy-section_A-text-line_1'),
            t('privacy-policy-section_A-text-line_2'),
            t('privacy-policy-section_A-text-line_3'),
            t('privacy-policy-section_A-text-line_4'),
            t('privacy-policy-section_A-text-line_5'),
            t('privacy-policy-section_A-text-line_6'),
          ].join('\\n\\n')
        )
      )}
      <strong>{parse(t('privacy-policy-section_B-title'))}</strong>
      {parse(
        breakTranslationNewlines(
          [
            t('privacy-policy-section_B-text-line_1'),
            t('privacy-policy-section_B-text-line_2'),
            t('privacy-policy-section_B-text-line_3'),
            t('privacy-policy-section_B-text-line_4'),
            t('privacy-policy-section_B-text-line_5'),
            t('privacy-policy-section_B-text-line_6'),
            t('privacy-policy-section_B-text-line_7'),
          ].join('\\n\\n')
        )
      )}
      <strong>{parse(t('privacy-policy-section_C-title'))}</strong>
      {t('privacy-policy-section_C-text-line_1')}
      <strong>{parse(t('privacy-policy-section_D-title'))}</strong>
      {parse(
        breakTranslationNewlines(
          [
            t('privacy-policy-section_D-text-line_1'),
            t('privacy-policy-section_D-text-line_2'),
          ].join('\\n\\n')
        )
      )}
      <strong>{parse(t('privacy-policy-section_E-title'))}</strong>
      {t('privacy-policy-section_E-text-line_1')}
      <strong>{parse(t('privacy-policy-section_F-title'))}</strong>
      {parse(
        breakTranslationNewlines(
          [
            t('privacy-policy-section_F-text-line_1'),
            t('privacy-policy-section_F-text-line_2'),
          ].join('\\n\\n')
        )
      )}

      <strong>{parse(t('privacy-policy-section_G-title'))}</strong>
      {parse(
        breakTranslationNewlines(
          [
            t('privacy-policy-section_G-text-line_1'),
            t('privacy-policy-footer'),
          ].join('\\n\\n')
        )
      )}
    </InfoModal>
  );
};

export default memo(LegalNoteModal);
